<script>
  // Imported this mixin from https://github.com/Kelin2025/vue-responsive-components
  // in order to easily have it run through the babel transpiler

  import { ResizeObserver as Polyfill } from '@juggle/resize-observer'
  const ResizeObserver = window.ResizeObserver || Polyfill

  export default {
    data () {
      return {
        el: {
          width: 0,
          height: 0,
          is: {},
        },
        resizeObserver: null,
      }
    },
    mounted () {
      if (
        typeof process === 'undefined' ||
        (!process.server && (this.breakpoints || this.$options.breakpoints))
      ) {
        this.$nextTick(() => {
          const handleResize = entries => {
            window.requestAnimationFrame(() => {
              const cr = entries[0].contentRect
              this.el.width = cr.width
              this.el.height = cr.height
              const conds = Object.assign(
                {},
                this.breakpoints || {},
                this.$options.breakpoints || {},
              )
              for (const breakpoint in conds) {
                this.$set(this.el.is, breakpoint, conds[breakpoint](this.el))
              }
            })
          }

          if (!this.resizeObserver) {
            this.resizeObserver = new ResizeObserver(handleResize)
          }

          if (this.$el instanceof Element) {
            this.resizeObserver.observe(this.$el)
          }
        })
      }
    },
    beforeDestroy () {
      if (this.resizeObserver) {
        this.resizeObserver.unobserve(this.$el)
      }
    },
  }
</script>
